<template>
    <div class="address-subform">
        <alert theme="danger" v-if="$v.$anyError">
            {{ errorMessage }}
        </alert>

        <template v-if="withRecipient">
            <form-element label="Steht dein Nachname an deinem Briefkasten?" :optional="optional" component="toggle" :props="{options: $select('yes_no')}" v-model="hasRecipient"/>
            <form-element label="Name der Person/der Wohneinrichtung am Briefkasten" name="recipient" :optional="optional" v-if="!hasRecipient"/>
        </template>

        <flex>
            <form-element class="flex-grow-1 mr-3" label="Straße" v-model="$form.street" v-c:invalid="$v.street.$anyError"/>
            <form-element class="street-number" label="Nr." v-model="$form.street_number" v-c:invalid="$v.street_number.$anyError"/>
        </flex>

        <flex>
            <form-element class="post-code mr-3" label="PLZ" v-model="$form.post_code" v-c:invalid="$v.post_code.$anyError"/>
            <form-element class="flex-grow-1" label="Ort" v-model="$form.city" v-c:invalid="$v.city.$anyError"/>
        </flex>

        <form-element label="Land" name="country" :optional="optional" component="v-select" :props="{options: $select('country')}"/>
    </div>
</template>

<style lang="scss">
    .address-subform {
        .street-number,
        .post-code {
            width: 80px;
        }
    }
</style>

<script>
    export default {
        mixins: [require('$src/mixins/subformMixin').default],

        data() {
            return {
                errorMessage: this.__("validation/required_multiple"),
                hasRecipient: 1,
            };
        },

        props: {
            withRecipient: {type: Boolean, default: false},
            optional: {type: Boolean, default: null},
        },
    };
</script>